import clsx from 'clsx';
import * as React from 'react';
import useStyles from './TextField.styles';
import { useState } from 'react';
import { Icon } from '../Icon';

export interface ITextFieldProps
  extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'onChange' | 'name' | 'placeholder'
  > {
  onChange?: (v: string) => void;

  // to make sure Trans works
  placeholder?: React.ReactElement;
  ref?: React.Ref<HTMLInputElement>;
  variant?: 'white' | 'gray';
  name?: string;
  value?: string;
  error: JSX.Element | null;
  isDisabled?: boolean;
  isExocadInput?: boolean;
  isNumeric?: boolean;
}

const TextField: React.FC<ITextFieldProps> = React.forwardRef<
  HTMLInputElement,
  ITextFieldProps
>(
  (
    { error, variant, isExocadInput, isNumeric = false, ...inputProps },
    ref,
  ) => {
    const classes = useStyles();
    const [isFocused, setIsFocused] = useState(false);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const adjustedValue = isNumeric
        ? e.target.value.replace(/\D/g, '')
        : e.target.value;
      inputProps?.onChange?.(adjustedValue);
    };
    return (
      <>
        <div
          className={clsx(
            classes.root,
            error && classes.withError,
            variant === 'gray' && classes.gray,
          )}
        >
          <label
            className={
              isFocused
                ? error
                  ? clsx(
                      isExocadInput
                        ? classes.exocadLabelBorderFocus
                        : classes.labelBorderFocus,
                      classes.withError,
                    )
                  : isExocadInput
                  ? classes.exocadLabelBorderFocus
                  : classes.labelBorderFocus
                : inputProps.value
                ? error
                  ? clsx(
                      classes.labelBorderFocus,
                      classes.labelBorderBlur,
                      classes.withError,
                    )
                  : clsx(classes.labelBorderFocus, classes.labelBorderBlur)
                : error
                ? clsx(classes.label, classes.withError)
                : classes.label
            }
          >
            {inputProps.placeholder}
          </label>
          <input
            value={inputProps.value}
            ref={ref}
            {...(inputProps.autoFocus ? { 'data-autofocus': true } : {})}
            onChange={inputProps.onChange ? handleChange : undefined}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            disabled={inputProps.isDisabled}
            className={isExocadInput ? classes.exocadInput : classes.input}
          />
        </div>
        <div className={classes.errorDiv}>
          {error && (
            <div className={clsx(classes.withError, classes.errorMsg)}>
              <div>
                <Icon type={'bang'} size={14} className={classes.bang} />
              </div>

              {error}
            </div>
          )}
        </div>
      </>
    );
  },
);

export default TextField;
